import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'

// 密钥对生成 http://web.chacuo.net/netrsakeypair

const publicKey = '-----BEGIN PUBLIC KEY-----\n' +
  'MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAwbEJNOAJNzk+CIY0l2PH\n' +
  'MN1uk6waX7U8jkxD4/A8vg4/l6dVZ2fsMr/nVzfHpn3epjSlgnfG6agKLAjOiwB7\n' +
  'H+0X4NW12KiJmaTwvAk8YXnvCHwiehK3qAmL6x0P3g1bQJQ3xkVsCiFc4hk6ouDw\n' +
  'phEWEMzTQvf7EX3Z19dqmBMuhwxKGEGrFscestoqJSX5zAsZNy43OJ07Ph/rk2Gs\n' +
  '8kF/YSxKL6e8+gkLr5+vh1sabdb0Ox6+xfVgCropXd6mbjW6t6tHKOOC/ELgcPOX\n' +
  'fMoB4BE2Eshl7yIOLiE+C7kF8vX1b3qUEj9MWCfaPmTxCS7FKQ++1nzrwUL0qmRi\n' +
  'BI281sdCvxPsByr1rF/Tlm/Ue+gWyK17kaHJk8NijWv8eiUSno0jC6k+BmCnfxkK\n' +
  'UuhxoiFIsSG2bWHYkKqIY2mhy2UXTO1MFLsaGX9qvDmTD2HEWX88uPDXvdUsyXu+\n' +
  'zhW4RTQv27FNbm6goCXkWV3JpDNddL/x6EPzG9JnWYpg3jN0aDTFyR9e54guTIDB\n' +
  'Kd162pSLlPcwZQomXB0aLu8bVbAHJ8m+hskTYfEDoBD60DBQ49zBZbIJMwl883/U\n' +
  'Pgsf1j3+g0MxwaCF7DPQEdVkOp6/gd3ckEluWRlvGmCjFfDKfb6M7Gmw/WFlJDPO\n' +
  '2cjVcusK4jMU8bnzKmEMcP8CAwEAAQ==\n' +
  '-----END PUBLIC KEY-----'

// const privateKey = ''
// 海康接口解密钥匙
const privateKey=
                   "MIIJQgIBADANBgkqhkiG9w0BAQEFAASCCSwwggkoAgEAAoICAQDBsQk04Ak3OT4I" +
                    "hjSXY8cw3W6TrBpftTyOTEPj8Dy+Dj+Xp1VnZ+wyv+dXN8emfd6mNKWCd8bpqAos" +
                    "CM6LAHsf7Rfg1bXYqImZpPC8CTxhee8IfCJ6EreoCYvrHQ/eDVtAlDfGRWwKIVzi" +
                    "GTqi4PCmERYQzNNC9/sRfdnX12qYEy6HDEoYQasWxx6y2iolJfnMCxk3Ljc4nTs+" +
                    "H+uTYazyQX9hLEovp7z6CQuvn6+HWxpt1vQ7Hr7F9WAKuild3qZuNbq3q0co44L8" +
                    "QuBw85d8ygHgETYSyGXvIg4uIT4LuQXy9fVvepQSP0xYJ9o+ZPEJLsUpD77WfOvB" +
                    "QvSqZGIEjbzWx0K/E+wHKvWsX9OWb9R76BbIrXuRocmTw2KNa/x6JRKejSMLqT4G" +
                    "YKd/GQpS6HGiIUixIbZtYdiQqohjaaHLZRdM7UwUuxoZf2q8OZMPYcRZfzy48Ne9" +
                    "1SzJe77OFbhFNC/bsU1ubqCgJeRZXcmkM110v/HoQ/Mb0mdZimDeM3RoNMXJH17n" +
                    "iC5MgMEp3XralIuU9zBlCiZcHRou7xtVsAcnyb6GyRNh8QOgEPrQMFDj3MFlsgkz" +
                    "CXzzf9Q+Cx/WPf6DQzHBoIXsM9AR1WQ6nr+B3dyQSW5ZGW8aYKMV8Mp9vozsabD9" +
                    "YWUkM87ZyNVy6wriMxTxufMqYQxw/wIDAQABAoICAQCEDLZCHhsqUxQ/q39fVt8O" +
                    "KWihtMumRGEsgkImvDotOHmSYrqO7QLS9pI5nAW5NEb++RV9hTtPQQjuTHLDwWgv" +
                    "s+x7lDeNphlpblHRYFqR+hdEqZy3rNsY7Kk/eWi/8kssE+CSg/HMVkKEwr5/HOvz" +
                    "y+JHQd0l4vqASlSiGnLJiwpFd9NsBhkmRkpflOz2tpU+zrI6NH/hURB6ojhxGj5W" +
                    "SuEU1qUdKDZmIJSe/zckCLBUAiAvzh4xx7/akGBzZsAAkxDg9xxke/dpFA7/8pJs" +
                    "uSveHt3GoGkeRxFz0aYDR/kOUzEo92DLr+vUjhb0Qs0xfXldLSbmA/SWpZc4M4e+" +
                    "c052rPLRry9SfAvBVSeGI7jpfhKRGWgl+Rgg8cC6Zd6pPyl8MXh+IuLlEhn3akMV" +
                    "dkiZ+N2iYmhJyQEdCYfYGWdChFoJwsWI/kXgLC6LUt+PhCeSoecOFQwNJ9oYnVLd" +
                    "87nJgbIerpTgLu5NAbPaRlapIxLOSOmef/BXzEUnepKomvACWxmQrkI08KfTGzLq" +
                    "dBmBKihUJPQp3mzzMcSdqhOn2MI8ohrGpTUYGyigD8lvxIykBaPYiSEdSxghWPAR" +
                    "TcLOBvggPmrV5lXsDdSCM+KyEqmitX804WAmWE1W6cK4RPN5H1dbAglBNJRKX8gi" +
                    "mhbNwKhRRJcfxPEj8KPmQQKCAQEA49toanHPKN66c4TyGfatYIjneOXJaAOINW5a" +
                    "p7wrE4KAUYcBNapkZYk/+Hvk8tPfjBfmQnsEcZD+m86c6nKQXg/F10B2pZyx5nCp" +
                    "+bwoxPcHmk225G9TSFKlUl4Uxd/oM2hdgtRKb+Ety6XIRkEP0llwvBSNsej6Byn9" +
                    "s5pBkZbRLudhN3nZ6NG126a6zFZaZsPwUjTU7xVfGxLGgccvSLfan19qJvlMkn09" +
                    "tudu4VnQ43+g36x8wg8gKdl5j4run7wMQrqw1wTeaulgeJXFPO5pginFwLL1w0d+" +
                    "cN/T3NdUpXjbudXUztSXsR0cT7ac7+7R6fhxrpSLLHpGF2IeRQKCAQEA2Z1aCYWL" +
                    "BPGyOfLUBzLhwMgilLVs2FLd0znAFl585K+cPVJYS0wxlNTz8Ll1jAxfsFXKWK+5" +
                    "bjebIu8aVHpKNuPdPho6c8jN1qOrSC0LFQXPAvcT3BCMabX9w/32E9EVDvV8AGfl" +
                    "OZw0g4tYTxvQ45PdgvNc4W+b57f54fJt6vrlG4MBJntO7AEBh1QSlM0NfKaRIYLP" +
                    "LGggu9Zh9KlnnawHnz4OMUf/CaUNz6waIK1r8gjnk5DFqQL5o5tWdGF0GgFmpHXJ" +
                    "83f9YCwYBGFl5TWQolDyzXDd2vekwF+zeYThG2XP7lgO+sYCme1fAQDkmSIsE7Fk" +
                    "NIN+Fu6wHW74cwKCAQBlXJtsjshbJAnJjeCtUCD8iqp+C6q3DKsxKbBGYdy/xxQS" +
                    "MH6HQw96Y74DagoFQ990UMVr2ZG2e4vn/9eqK+CxF08pXFHrhnNVUdUrdVqllEbb" +
                    "i6rKoANqbumAZL3U8LA4/jprEskyT/exWkRnjFXfe049PN9zv3JKcZGcrghxHahc" +
                    "ty12Ikyf13qRBfCfKeL5SDzGNR5sZRNz1bxcyyDrtm4Y67crM0eu+uvTS8z1jqDw" +
                    "Mzx7hB3TriresxHymxlgEaVaofY9ELtoz/zMZ8PgQSbKco64FGRjxJAo4kk7Osc6" +
                    "/TKxzr/maog4j/yiMVhLG/BhptXbldT7qkE38bwJAoIBAArZGDrvSE3Xyp2u6Djv" +
                    "pWdZ0rd9D8782ogEEfpLfYhc5Ln9197xDmuv7fUrGZwApeiBblPbdq/y363vI23g" +
                    "psBzvXyyDAXnlbNEd25iqHHE11v7eyb2QDmo09yoVVMJkjYrsKHIjBnCGrAQCzfu" +
                    "WAxwO5OilBe825XCixdjYW1cUn17m1wSu41yQ2Q+oap/SlPTbdqwzakWC8OxXTK4" +
                    "Gy01/S9IBacZQrJ1YuneV3MXkhD/tqOZjPDu8Aji3n1wujvto/NA1+9mJOBdclkN" +
                    "jenOMMaWqHPrU3Pt8m2Ql77QC/S0r5ffFegUZN7NgXXoWHz1wiK9LhScFXYJMghV" +
                    "ltcCggEAJ4JbLxUMDYr86xuBiEj1hGnha7M9vJF6aiSG4JAMvgC1yh6N25QVGWqW" +
                    "jfwydAxchRo8G3D7241e3fTQxZN5ufT1z/1Ts2q6gJ/+Qhn7gl1to0Pj5yjItnpv" +
                    "crYWQayt6n0LxQ9v8iLC6XPL5joi8Jv4OCV84XQSxzqKY6okkgEBBXXGAO4ZVPbu" +
                    "qNb0y3zlh/cBNK8gVw5nd895j6Y9srxAd+1hiyxlMBF74FZWE0EsRv7cbEqL/FEH" +
                    "ZF4VaFYo37d7trb6uKTdt2JGSlHK+WpDWNUJ8c4t9ZX5ZFiXOz/Xap+pnAnQ8Cbq" +
                    "q4fUq+jejXrSl9/QEJpO2H04a1a1Ig==";
// 加密
export function encrypt(txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(publicKey) // 设置公钥
  return encryptor.encrypt(txt) // 对数据进行加密
}

// 解密
export function decrypt(txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPrivateKey(privateKey) // 设置私钥
  return encryptor.decrypt(txt) // 对数据进行解密
}

